<template>
  <div class="termsContainer">
    <div v-for="(item, i) in props.list" :key="i">
      <!-- ●{{ item.name }} -->
      <div v-html="getText(item)" />
    </div>
  </div>
</template>

<script setup>
import config from "~/public/config.json";

const props = defineProps({
  list: {
    type: Array,
    requeired: true,
    default: () => [],
  },
});

const getText = (text) => {
  const textToReplace = "Contact Us";
  const styledSpan = `<a class="sp" style="font-weight: 400;font-size: 14px;color: #0189be;
  line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="${config.contactUs}" target="_blank">${textToReplace}</a>`;
  const regex = new RegExp(textToReplace, "g");

  const textToReplace2 = "Software Upgrade Guide";
  const styledSpan2 = `<a class="sp" style="font-weight: 400;font-size: 14px;color: #0189be;
  line-height: 20px;text-align: left;cursor: pointer;text-decoration-line: underline;" href="${config.SoftwareUpgradePolicy}" target="_blank">${textToReplace2}</a>`;
  const regex2 = new RegExp(textToReplace2, "g");

  // 使用正则表达式替换文本
  const resultString = text.replace(regex, styledSpan);
  const resultString2 = resultString.replace(regex2, styledSpan2);

  return `<span style="font-size:20px">●</span>` + resultString2;
};
</script>

<style lang="less" scoped>
.termsContainer {
  background: #292929;
  border-radius: 10px;
  padding: 18px 18px;
  margin-top: 70px;
  margin-bottom: 90px;
  .fcf(14,#fff);
  .lh(28);
  div {
    div {
      display: inline-block;
    }
  }

  a {
    font-weight: 400;
    font-size: 14px;
    // color: #ffffff;
    color: #0189be;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    cursor: pointer;
    text-decoration-line: underline;
    // background: linear-gradient(
    //   309.92993038984974deg,
    //   #0189be 0%,
    //   #32a395 100%
    // );
    // display: inline-block;
    // font-size: 14px;
    // background-clip: text;
    // -webkit-background-clip: text;
    // color: transparent;
  }
}
</style>
